import React from 'react'
import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'
import Flex from '../../../components/Box/Flex'
import { HamburgerIcon, HamburgerCloseIcon } from '../icons'
import MenuButton from './MenuButton'

interface Props {
  isPushed: boolean
  isDark: boolean
  togglePush: () => void
  href: string
  hideMenuButton?: boolean
}

const blink = keyframes`
  0%,  100% { transform: scaleY(1); } 
  50% { transform:  scaleY(0.1); } 
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  .mobile-icon {
    width: 38px;
    margin-left: 16px;
    margin-right: 32px;
    ${({ theme }) => theme.mediaQueries.nav} {
      display: none;
    }
  }
  .desktop-icon {
    width: 160px;
    display: none;
    margin-top: 10px;
    ${({ theme }) => theme.mediaQueries.nav} {
      display: block;
    }
  }
  .right-eye {
    animation-delay: 20ms;
  }
  &:hover {
    .left-eye,
    .right-eye {
      transform-origin: center 60%;
      animation-name: ${blink};
      animation-duration: 350ms;
      animation-iteration-count: 1;
    }
  }

  @media (max-width: 359px) {
    display: none;
  }
`

const Logo: React.FC<Props> = ({ isPushed, togglePush, href, hideMenuButton }) => {
  const isAbsoluteUrl = href.startsWith('http')
  const innerLogo = (
    <>
      <img className="mobile-icon" src="/logo.png" alt="HyperJump Logo" />
      <img className="desktop-icon" src="/hyperjump-name-logo.png" alt="HyperJump Logo" />
    </>
  )

  return (
    <Flex>
      {!hideMenuButton ? (
        <MenuButton aria-label="Toggle menu" onClick={togglePush}>
          {isPushed ? (
            <HamburgerCloseIcon width="24px" color="textSubtle" />
          ) : (
            <HamburgerIcon width="24px" color="textSubtle" />
          )}
        </MenuButton>
      ) : (null)}
      
      {isAbsoluteUrl ? (
        <StyledLink as={undefined} href={href} aria-label="HyperJump home page">
          {innerLogo}
        </StyledLink>
      ) : (
        <StyledLink to={href} aria-label="HyperJump home page">
          {innerLogo}
        </StyledLink>
      )}
    </Flex>
  )
}

export default React.memo(Logo, (prev, next) => prev.isPushed === next.isPushed && prev.isDark === next.isDark)
